import { createContext, useContext } from "react";

type AuthContextType = {
  session: any;
  profile: any;
  loading: boolean;
};

export const AuthContext = createContext<AuthContextType>({
  session: null,
  profile: null,
  loading: true,
});

export const useAuth = () => useContext(AuthContext);